import { render, staticRenderFns } from "./mode-title.vue?vue&type=template&id=b7b8c850&scoped=true"
import script from "./mode-title.vue?vue&type=script&lang=js"
export * from "./mode-title.vue?vue&type=script&lang=js"
import style0 from "./mode-title.vue?vue&type=style&index=0&id=b7b8c850&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b8c850",
  null
  
)

export default component.exports